import { Link } from "wouter";
import { ArrowRight } from "lucide-react";

export function WhyNotKeywords() {
  const comparisons = [
    {
      label: "vs. legacy keyword blockers",
      heading: "Not keyword filters",
      body: "Keywords miss slang, coded language, and implied threats. HarmCheck’s classifiers understand context, intent, and nuance across nearly 50 categories — catching what a keyword list never could."
    },
    {
      label: "vs. general-purpose tools",
      heading: "Not a generic tool",
      body: "General models aren’t trained on regulatory harm, employment law violations, or MNPI patterns. HarmCheck’s classifiers are purpose-built and continuously refined on the specific language of organizational risk."
    },
    {
      label: "vs. manual document review",
      heading: "Not a human review team",
      body: "Manual review is slow, expensive, and inconsistent. HarmCheck processes 20,000+ pages per hour with 91%+ accuracy — delivering results in hours that would take a review team weeks to complete."
    }
  ];

  return (
    <section id="why-harmcheck-comparison" className="py-24 bg-background border-b border-border/40">
      <div className="container mx-auto px-0 md:px-6">
        <div className="text-center mb-16 px-6 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            Why HarmCheck
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Keyword blockers catch the obvious. General-purpose tools weren’t trained for this. HarmCheck was built for one purpose: detecting harm in organizational communications with forensic precision.
          </p>
          <Link href="/why-harmcheck" className="mt-6 inline-flex items-center text-primary-text font-medium text-base hover:underline group">
            Read more about why HarmCheck
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {comparisons.map((c, i) => (
            <div
              key={i}
              className="border border-border/50 bg-card p-8 hover:border-primary/30 transition-colors"
            >
              <div className="text-xs font-semibold uppercase tracking-wider text-primary-text mb-4">{c.label}</div>
              <h3 className="text-xl font-bold mb-4">{c.heading}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
